// extracted by mini-css-extract-plugin
export default {"tooltip":"Np-z","sharingV2":"Op-z","sharingIconsV2":"Pp-z","links":"Qp-z","link":"Rp-z","facebookV2":"Sp-z","twitterV2":"Tp-z","pinterestV2":"Up-z"};